import { formatDate } from "@angular/common";
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { GoogleMap } from "@angular/google-maps";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { SharedService } from "src/app/shared-modules/shared.service";
import { CorporateService } from "../corporate.service";

@Component({
  selector: "app-corporate-truck-details",
  templateUrl: "./corporate-truck-details.component.html",
  styleUrls: ["./corporate-truck-details.component.css"],
})
export class CorporateTruckDetailsComponent implements OnInit {
  isBackButtonClicked: boolean = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.SearchTruckDetails) {
      $event.returnValue = "Refresh/Reload will cause data loss.";
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (this.isBackButtonClicked) {
      return;
    }
    if (window.confirm("Changes you made may not be saved.")) {
      this.isBackButtonClicked = true;
      this.SearchTruckDetails = null;
      window.location.href = '/corporate';
    } else {
      history.pushState(null, '', window.location.href);
    }
  }

  @ViewChild(GoogleMap) map: GoogleMap | any;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  bookingDetails: boolean = true;
  billingForm!: FormGroup;
  panel: boolean = true;
  panel1: boolean = false;
  panel2: boolean = false;
  panel3: boolean = false;
  panelForm: boolean = true;
  panel1form1: boolean = false;
  panel2form1: boolean = false;
  panel3form1: boolean = false;
  downImg: boolean = true;
  checkImg: boolean = false;
  downImg1: boolean = true;
  checkImg1: boolean = false;
  downImg2: boolean = true;
  checkImg2: boolean = false;
  downImg3: boolean = true;
  checkImg3: boolean = false;
  billingEdit: boolean = false;
  editBilling: boolean = true;
  loading: boolean = false;
  loadDetails: boolean = false;
  loadDetailsBtn: boolean = false;
  paymentDetailsBtn: boolean = false;
  selecteLoadCategory: boolean = false;
  othersType: boolean = false;
  TruckDetailsBtn: boolean = true;
  loadCategory: any;
  paymentBtn: boolean = false;
  truckCategory: any = [];
  materialDetails: any;
  otherValue: any;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  mapConfigurations: any;
  inititalCoordinates: any;
  coordinatesForm!: FormGroup;
  token: any;
  mapHtml: any;
  mapOptions: any;
  mapGoogle: any;
  loadCategorySelectedindex: any;
  loadSelectedCategory: any;
  completePickUpAddress: any;
  completeDropAddress: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  dropAutoComplete: any;
  drop_long_name: any = "";
  drop_short_name: any = "";
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  directionsService: any;
  directionsRenderer: any;
  googleAddress: any;
  SearchTruckDetails: any;
  searchPickupDetails: any = [];
  pickup_postal_code: any;
  dropoff_postal_code: any;
  today: any;
  profileValues: any;
  profileDetails: any;
  selectedLoadedQuantity: any;
  payment_condition: boolean = false;
  pickup_address: any;
  drop_address: any;
  payment_check: any;
  terms_check: any;
  locationError: boolean = false;
  locationsMatch: boolean = false;
  showCloseIconPick = false;
  showCloseIconDrop = false;
  pickup_state: any = "";
  pickup_country: any = "";
  drop_state: any = "";
  drop_country: any = "";
  selectedMaterial: any = null;

  constructor(
    private services: CorporateService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private shrdSrvcs: SharedService,
    private router: Router
  ) {
    this.minDate.setDate(this.minDate.getDate() - 0);
    this.maxDate.setDate(this.maxDate.getDate() + 2);
  }

  ngOnInit(): void {
    history.pushState(null, '', window.location.href);
    this.token = sessionStorage.getItem("corporate_token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.getLoadDetails();
    this.GetCategory();
    this.generateForms();
    this.getProfileDetails();

    this.shrdSrvcs.currentsearchDetails.subscribe(
      (result: any) => {
        this.generateForms();
        if (result && result.searchData) {
          this.SearchTruckDetails = result.searchData;
          this.searchPickupDetails = result.searchData;
          this.GetCategory();
          this.coordinatesForm.controls["from_area_name"].setValue(
            `${this.searchPickupDetails.completePickUpAddress?.formatted_address}`
          );

          this.coordinatesForm.controls["to_area_name"].setValue(
            `${this.SearchTruckDetails.completeDropAddress?.formatted_address}`
          );
          this.coordinatesForm.controls["date"].setValue(
            `${this.SearchTruckDetails.date}`
          );
          this.coordinatesForm.controls["truck_category_name"].setValue(
            `${this.SearchTruckDetails.truck_category}`
          );
          this.coordinatesForm.controls["total_tons"].setValue(
            `${this.SearchTruckDetails.truckweight.truck_weight}`
          );
          this.pickup_short_name =
            this.SearchTruckDetails.fromLocation.from_city_name;
          this.pickup_postal_code =
            this.SearchTruckDetails.fromLocation.from_pincode;
          this.pickupLat = this.SearchTruckDetails.fromLocation.from_lat;
          this.pickupLong = this.SearchTruckDetails.fromLocation.from_long;
          this.drop_long_name = this.SearchTruckDetails.toLocation.to_area_name;
          this.drop_short_name =
            this.SearchTruckDetails.toLocation.to_city_name;
          this.dropoff_postal_code =
            this.SearchTruckDetails.toLocation.to_pincode;
          this.dropLat = this.SearchTruckDetails.toLocation.to_lat;
          this.dropLong = this.SearchTruckDetails.toLocation.to_long;
          this.completePickUpAddress =
            this.searchPickupDetails.completePickUpAddress;
          this.completeDropAddress =
            this.SearchTruckDetails.completeDropAddress;
          this.coordinatesForm
            .get("from_area_name")
            ?.valueChanges.subscribe((value) => {
              this.showCloseIconPick = !!value;
            });
          this.coordinatesForm
            .get("to_area_name")
            ?.valueChanges.subscribe((value) => {
              this.showCloseIconDrop = !!value;
            });
          this.GetTruckWeight();
        } else {
          this.router.navigateByUrl("/corporate");
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  generateForms() {
    this.billingForm = this.formBuilder.group({
      username: ["", Validators.required],
      address_line: ["", Validators.compose([Validators.required])],
      email: [
        "",
        Validators.compose([
          Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/),
        ]),
      ],
      city: ["", Validators.compose([Validators.required])],
      state: ["", Validators.compose([Validators.required])],
      pincode: ["", Validators.compose([Validators.required])],
      gst: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/),
        ]),
      ],
      gst_mode: ["fcm"],
      pickup_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\\s]+$/),
        ]),
      ],
      pickup_contact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      dropoff_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\\s]+$/),
        ]),
      ],
      dropoff_contact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      material: ["", Validators.compose([Validators.required])],
      terms_and_conditions: ["", Validators.compose([Validators.required])],
      insurance_acknowledgement: ["", Validators.required],
      payment_mode: ["", Validators.compose([Validators.required])],
      pay_as_load_quantity: ["", Validators.compose([Validators.required])],
      stop_contacts: this.formBuilder.array([])
    });
    this.today = new Date();
    this.coordinatesForm = this.formBuilder.group({
      from_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      date: [""],
      truck_category_name: ["", [Validators.required]],
      total_tons: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\d+(\.\d{1,3})?$/)
        ]),
      ],
      price_type: ["", Validators.required],
      total_price: [
        "",
        Validators.compose([
          Validators.pattern(/^(0|[1-9]\d*)$/),
        ]),
      ],
      price_per_ton: [
        "",
        Validators.compose([
          Validators.pattern(/^(0|[1-9]\d*)$/),
        ]),
      ],
      stops: this.formBuilder.array([]),
    });
    this.addStopField();
  }

  get calculatedPricePerTon() {
    const type = this.coordinatesForm?.get('price_type')?.value;
    const ppt = parseFloat(this.coordinatesForm?.get('price_per_ton')?.value) || 0;
    const tp = parseFloat(this.coordinatesForm?.get('total_price')?.value) || 0;
    const tons = parseFloat(this.coordinatesForm?.get('total_tons')?.value);

    if (type === 'total_price' && tons) {
      return (tp / tons).toFixed(2);
    }
    return ppt || 0;
  }

  get calculatedTotalPrice() {
    const type = this.coordinatesForm?.get('price_type')?.value;
    const ppt = parseFloat(this.coordinatesForm?.get('price_per_ton')?.value) || 0;
    const tp = parseFloat(this.coordinatesForm?.get('total_price')?.value) || 0;
    const tons = parseFloat(this.coordinatesForm?.get('total_tons')?.value);

    if (type === 'price_per_ton' && tons) {
      return (ppt * tons).toFixed(2);
    }
    return tp || 0;
  }
  GoTOBack() {
    if (this.panel3form1) {
      this.editLoadDetails();
    } else if (this.panel2form1) {
      this.editBookingDetails();
    } else {
      this.router.navigateByUrl("/");
    }
  }

  onDropChange(event: any) {
    this.geoCodeDrop(this.coordinatesForm.value.drop);
    this.checkLocations();
  }
  onInputPickUpchange(event: any) {
    this.geoCodePickUp(this.coordinatesForm.value.pickup);
    this.checkLocations();
  }
  checkLocations() {
    const pickups = this.coordinatesForm.get("pickup")?.value;
    const dropup = this.coordinatesForm.get("drop")?.value;
    if (pickups && dropup && pickups === dropup) {
      // this.snackBar.open(
      //   "Pickup and Drop-off locations should not be the same",
      //   "Fail",
      //   { duration: 5000 }
      // );
      // this.coordinatesForm.controls["pickup"].reset();
      // this.coordinatesForm.controls["drop"].reset();
      return;
    }
  }

  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        this.pickup_address = place.formatted_address;
        this.searchPickupDetails.fromLocation.from_area_name =
          this.pickup_address;
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);
              this.coordinatesForm.controls["from_area_name"].setValue(
                place.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }

  autoCompletePickupGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK && result && result.length > 0) {
        this.completePickUpAddress = result[0];
        this.pickup_postal_code = undefined;
        for (
          let i = 0;
          i < this.completePickUpAddress?.address_components.length;
          i++
        ) {
          if (
            this.completePickUpAddress?.address_components[i].types[0] ==
              "locality" &&
            this.completePickUpAddress?.address_components[i].types[1] ==
              "political"
          ) {
          }
          if (
            this.completePickUpAddress.address_components[i].types[0] ==
              "political" &&
            this.completePickUpAddress.address_components[i].types[1] ==
              "sublocality" &&
            this.completePickUpAddress.address_components[i].types[2] ==
              "sublocality_level_1"
          ) {
            this.pickup_long_name =
              this.completePickUpAddress.address_components[i].long_name;
          }
          if (
            this.completePickUpAddress.address_components[i].types.includes("postal_code")
          ) {
            this.pickup_postal_code = Number(this.completePickUpAddress.address_components[i].long_name);
          }
          if (this.pickup_short_name && this.pickup_long_name) {
          }
          if (this.completePickUpAddress.address_components[i].types[0] == "administrative_area_level_1") {
            this.pickup_state = this.completePickUpAddress.address_components[i].long_name;
          }
          if (this.completePickUpAddress.address_components[i].types[0] == "country") {
            this.pickup_country = this.completePickUpAddress.address_components[i].long_name;
          }
        }
      }
    });
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        this.drop_address = dropPlace.formatted_address;
        this.SearchTruckDetails.toLocation.to_area_name = this.drop_address;
        const geoCoder = new google.maps.Geocoder();

        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["to_area_name"].setValue(
                dropPlace.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }

  autoCompleteDropGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK && result && result.length > 0) {
        this.completeDropAddress = result[0];
        this.dropoff_postal_code = undefined;
        for (
          let i = 0;
          i < this.completeDropAddress?.address_components.length;
          i++
        ) {
          if (
            this.completeDropAddress.address_components[i].types[0] ==
              "locality" &&
            this.completeDropAddress.address_components[i].types[1] == "political"
          ) {
            this.drop_short_name =
              this.completeDropAddress.address_components[i].long_name;
          }
          if (
            this.completeDropAddress.address_components[i].types[0] ==
              "political" &&
            this.completeDropAddress.address_components[i].types[1] ==
              "sublocality" &&
            this.completeDropAddress.address_components[i].types[2] ==
              "sublocality_level_1"
          ) {
          }
          if (
            this.completeDropAddress.address_components[i].types.includes("postal_code")
          ) {
            this.dropoff_postal_code = Number(this.completeDropAddress.address_components[i].long_name);
          }
          if (this.completeDropAddress.address_components[i].types[0] == "administrative_area_level_1") {
            this.drop_state = this.completeDropAddress.address_components[i].long_name;
          }
          if (this.completeDropAddress.address_components[i].types[0] == "country") {
            this.drop_country = this.completeDropAddress.address_components[i].long_name;
          }
        }
      }
    });
  }

  public GetCategory() {
    this.services.GetCategory().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckCategory = response.body.data
          .filter((item: any) => item.truck_category_name)
          .sort((a: any, b: any) => a.truck_category_name.localeCompare(b.truck_category_name));
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  ngAfterViewInit(): void {
    var options = {
      types: ["geocode"], // Restrict to geographical locations
      componentRestrictions: { country: "in" },
    };
    const geoCoder = new google.maps.Geocoder();
    this.mapHtml = document.getElementById("map");
    this.mapOptions = {
      // How far the maps zooms in.
      zoom: 8,
      // Current Lat and Long position of the pin/
      center: new google.maps.LatLng(18.5204, 73.8567),
      disableDefaultUI: false, // Disables the controls like zoom control on the map if set to true
      scrollWheel: true, // If set to false disables the scrolling on the map.
      draggable: true, // If set to false , you cannot move the map around.
    };
    this.mapGoogle = new google.maps.Map(
      this.mapHtml as HTMLElement,
      this.mapOptions
    );
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      draggable: true,
      map: this.mapGoogle,
    });
    this.directionsRenderer.set(this.mapGoogle);
    this.directionsRenderer.addListener("directions_changed", () => {
      const directions = this.directionsRenderer.getDirections();
      const directionChanged = directions?.routes[0].legs[0];
      geoCoder.geocode(
        {
          address: directionChanged?.start_address,
        },
        (results: any, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            const latlong = new google.maps.LatLng(
              this.pickupLat,
              this.pickupLong
            );
            this.autoCompletePickupGeoCode(geoCoder, latlong);
          }
        }
      );
      geoCoder.geocode(
        {
          address: directionChanged?.end_address,
        },
        (results: any, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            const latlong = new google.maps.LatLng(this.dropLat, this.dropLong);
            this.autoCompleteDropGeoCode(geoCoder, latlong);
          }
        }
      );
    });
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
    this.pickupAddListener(geoCoder);
    this.dropAddListener(geoCoder);
    this.autoCoordinates(this.directionsService, this.directionsRenderer);
  }

  pickupAddListener(geoCoder: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        this.directionsService
          .route({
            origin: place.formatted_address as HTMLInputElement,
            destination: this.googleAddress?.completeDropAddress
              .formatted_address as HTMLInputElement,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          })
          .then((response: google.maps.DirectionsResult) => {
            this.directionsRenderer.setDirections(response);
            this.directionsRenderer.setMap(this.mapGoogle);
          });
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status: any) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);
            }
          }
        );
      }
    );
  }

  dropAddListener(geoCoder: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.directionsService
          .route({
            origin: this.googleAddress.completePickUpAddress
              .formatted_address as HTMLInputElement,
            destination: dropPlace.formatted_address as HTMLInputElement,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          })
          .then((response: google.maps.DirectionsResult) => {
            this.directionsRenderer.setDirections(response);
            this.directionsRenderer.setMap(this.mapGoogle);
          });
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);
            }
          }
        );
      }
    );
  }
  autoCoordinates(directionsService: any, directionsRenderer: any) {
    this.googleAddress = this.SearchTruckDetails;
    this.directionService(directionsService, directionsRenderer);
  }

  directionService(directionsService: any, directionsRenderer: any) {
    directionsService
      .route({
        origin: this.googleAddress?.completePickUpAddress
          .formatted_address as HTMLInputElement,
        destination: this.googleAddress?.completeDropAddress
          .formatted_address as HTMLInputElement,
        optimizeWaypoints: true,
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response: google.maps.DirectionsResult) => {
        directionsRenderer.setDirections(response);
        directionsRenderer.setMap(this.mapGoogle);
      });
    this.setPickupValuesInForm();
    this.setDropAddressInForm();
  }

  setPickupValuesInForm() {
    for (
      let i = 0;
      i < this.googleAddress?.completePickUpAddress.address_components.length;
      i++
    ) {
      if (
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[0] == "locality" &&
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[1] == "political"
      ) {
        this.pickup_short_name =
          this.googleAddress?.completePickUpAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[0] == "political" &&
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[1] == "sublocality" &&
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[2] == "sublocality_level_1"
      ) {
        this.pickup_long_name =
          this.googleAddress?.completePickUpAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[0] == "postal_code"
      ) {
        this.pickup_postal_code = Number(
          this.googleAddress?.completePickUpAddress.address_components[i]
            .long_name
        );
      }
      if (this.pickup_short_name && this.pickup_long_name) {
        this.coordinatesForm.controls["from_area_name"].setValue(
          `${this.pickup_long_name},${this.pickup_short_name}`
        );
      }
      if (this.googleAddress?.completePickUpAddress.address_components[i].types[0] == "administrative_area_level_1") {
        this.pickup_state = this.googleAddress?.completePickUpAddress.address_components[i].long_name;
      }
      if (this.googleAddress?.completePickUpAddress.address_components[i].types[0] == "country") {
        this.pickup_country = this.googleAddress?.completePickUpAddress.address_components[i].long_name;
      }
    }
  }

  setDropAddressInForm() {
    for (
      let i = 0;
      i < this.googleAddress?.completeDropAddress.address_components.length;
      i++
    ) {
      if (
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[0] == "locality" &&
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[1] == "political"
      ) {
        this.drop_short_name =
          this.googleAddress?.completeDropAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[0] == "political" &&
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[1] == "sublocality" &&
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[2] == "sublocality_level_1"
      ) {
        this.drop_long_name =
          this.googleAddress?.completeDropAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[0] == "postal_code"
      ) {
        this.dropoff_postal_code = Number(
          this.googleAddress?.completeDropAddress.address_components[i]
            .long_name
        );
      }
      if (this.drop_short_name && this.drop_long_name) {
        this.coordinatesForm.controls["to_area_name"].setValue(
          `${this.drop_long_name},${this.drop_short_name}`
        );
      }
      if (this.googleAddress?.completeDropAddress.address_components[i].types[0] == "administrative_area_level_1") {
        this.drop_state = this.googleAddress?.completeDropAddress.address_components[i].long_name;
      }
      if (this.googleAddress?.completeDropAddress.address_components[i].types[0] == "country") {
        this.drop_country = this.googleAddress?.completeDropAddress.address_components[i].long_name;
      }
    }
  }

  get stopsArray(): FormArray {
    return this.coordinatesForm.get('stops') as FormArray;
  }

  initStopAutocomplete(element: any, index: number) {
    const autocomplete = new google.maps.places.Autocomplete(element, {
      componentRestrictions: { country: 'in' },
      fields: ['formatted_address', 'geometry'],
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!(place?.geometry?.location)) {
        console.warn("Place returned with no geometry", place);
        return;
      }
      const address = place.formatted_address || '';
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const geoCoder = new google.maps.Geocoder();
      // First geocode to extract detailed components
      geoCoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          const components = results[0].address_components;
          let area_name = '';
          let city_name = '';
          let pincode = 0;
          for (let comp of components) {
            if (
              comp.types.includes('sublocality_level_1') ||
              comp.types.includes('neighborhood') ||
              comp.types.includes('sublocality')
            ) {
              area_name = comp.long_name;
            }
            if (comp.types.includes('locality')) {
              city_name = comp.long_name;
            }
            if (comp.types.includes('postal_code')) {
              pincode = parseInt(comp.long_name, 10);
            }
          }
          // fallback area_name
          if (!area_name && city_name) area_name = city_name;
          // Patch initial values
          this.stopsArray.at(index).patchValue({
            address,
            lat: lat.toFixed(4),
            lng: lng.toFixed(4),
            area_name,
            city_name,
            pincode,
            complete_address:
              place.formatted_address ||
              results[0].formatted_address ||
              address,
          });
          // Reverse geocode again to ensure complete formatted address
          this.reverseGeoCodeStop(geoCoder, { lat, lng }, index);
          // Always add new blank stop after selecting a stop
          if (index === this.stopsArray.length - 1) {
            this.addStopField();
          }
        }
      });
    });
    // ensure direction renderer refresh
    this.directionService(this.directionsService, this.directionsRenderer);
  }

  reverseGeoCodeStop(geoCoder: any, latlong: any, index: number) {
    geoCoder.geocode({ location: latlong }, (result: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK && result.length > 0) {
        const components = result[0].address_components;
        let area_name = '';
        let city_name = '';
        let pincode = 0;
        for (let comp of components) {
          if (
            comp.types.includes('sublocality_level_1') ||
            comp.types.includes('neighborhood') ||
            comp.types.includes('sublocality')
          ) {
            area_name = comp.long_name;
          }
          if (comp.types.includes('locality')) {
            city_name = comp.long_name;
          }
          if (comp.types.includes('postal_code')) {
            pincode = parseInt(comp.long_name, 10);
          }
        }
        // overwrite with most complete address
        const formatted = result[0].formatted_address;
        this.stopsArray.at(index).patchValue({
          area_name,
          city_name,
          pincode,
          complete_address: formatted,
        });
      }
    });
  }

  moveStopUp(index: number): void {
    if (index === 0) return;
    const stops = this.stopsArray;
    const current = stops.at(index);
    const prev = stops.at(index - 1);
    stops.setControl(index, prev);
    stops.setControl(index - 1, current);
  }

  moveStopDown(index: number): void {
    if (index === this.stopsArray.length - 1) return;
    const stops = this.stopsArray;
    const current = stops.at(index);
    const next = stops.at(index + 1);
    stops.setControl(index, next);
    stops.setControl(index + 1, current);
  }

  removeStopField(index: number): void {
    this.stopsArray.removeAt(index);
  }

  public GetTruckWeight() {}
  GoToLoadDetails() {
    const pickups = this.coordinatesForm.get("from_area_name")?.value;
    const dropup = this.coordinatesForm.get("to_area_name")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }
    const numericRegex = /^(0|[1-9]\d*)$/;
    const numericRegexWt = /^\d+(\.\d{1,3})?$/;

    if (
      this.coordinatesForm.value.total_tons == "" ||
      !numericRegexWt.test(this.coordinatesForm.value.total_tons)
    ) {
      this.snackBar.open("Please enter Total Tons (can be upto 3 decimal places)", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (!this.coordinatesForm.value.price_type) {
      this.snackBar.open("Please select Price Type", "Fail", {
        duration: 5000,
      });
      return;
    } else if (this.coordinatesForm.value.price_type === 'price_per_ton') {
      if (
        this.coordinatesForm.value.price_per_ton == "" ||
        !numericRegex.test(this.coordinatesForm.value.price_per_ton)
      ) {
        this.snackBar.open("Please enter Price Per Ton in numbers", "Fail", {
          duration: 5000,
        });
        return;
      }
    } else if (this.coordinatesForm.value.price_type === 'total_price') {
      if (
        this.coordinatesForm.value.total_price == "" ||
        !numericRegex.test(this.coordinatesForm.value.total_price)
      ) {
        this.snackBar.open("Please enter Total Price in numbers", "Fail", {
          duration: 5000,
        });
        return;
      }
    }

    if (this.coordinatesForm.invalid) {
      this.coordinatesForm.markAllAsTouched;
      this.snackBar.open("Please provide all the mandatory fields", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.panel2 = true;
    this.panel2form1 = true;
    this.panelForm = false;

    this.TruckDetailsBtn = false;
    this.downImg = false;
    this.checkImg = true;
    this.loadDetailsBtn = true;
    this.paymentBtn = false;
  }
  GoToPayments() {
    if (
      this.loadSelectedCategory === "" ||
      this.billingForm.value.material === ""
    ) {
      this.snackBar.open("Please select material", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.panel3 = true;
    this.panel3form1 = true;
    this.selecteLoadCategory = true;
    this.paymentBtn = true;
    this.payment_condition = true;
    this.loadDetailsBtn = false;
    this.panel2form1 = false;
    this.TruckDetailsBtn = false;
    this.downImg2 = false;
    this.checkImg2 = true;
  }
  BillingEdit() {
    this.billingEdit = true;
    this.editBilling = false;
  }
  getLoadDetails() {
    this.services.GetLoadDetails(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.loadCategory = response.body.data;
          this.downImg1 = false;
          this.checkImg1 = true;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  public loadCatChange(category: any, index: any) {
    this.materialDetails = "";
    this.loadSelectedCategory = category;
    this.loadCategorySelectedindex = index;
    this.materialDetails = this.loadCategory.find((ele: any) => {
      return ele.load_category === category;
    });
  }

  getProfileDetails() {
    this.loading = true;
    this.services.GetProfile(this.token).subscribe(
      (response: any) => {
        this.profileValues = response.body.data;
        this.profileDetails = response.body.data.billing_address;
        if (!this.profileDetails) {
          this.billingEdit = true;
          this.editBilling = false;
        } else {
          this.editBilling = true;
          this.billingForm.patchValue({
            username: this.profileDetails.username,
            address_line: this.profileDetails.address_line,
            city: this.profileDetails.city,
            state: this.profileDetails.state,
            pincode: this.profileDetails.pincode,
            gst: this.profileDetails.gst,
          });
        }
        this.loading = false;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  selectLoadedQty(event: any) {
    this.selectedLoadedQuantity = event;
  }
  others(eve: any) {
    this.selectedMaterial = eve;
    if (eve == "Others") {
      this.otherValue = eve;
      this.othersType = true;
    } else {
      this.othersType = false;
    }
  }
  isValidGST(gst: string): boolean {
    if (!gst) return false;
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gst.toUpperCase());
  }

  get stopContactsArray(): FormArray {
    return this.billingForm.get('stop_contacts') as FormArray;
  }
  get stopContactsControls(): FormGroup[] {
    return this.stopContactsArray.controls as FormGroup[];
  }

  get filteredStopContacts(): FormGroup[] {
    return this.stopContactsArray.controls
      .map((ctrl, index) => {
        const stopLocation = this.stopsArray.at(index)?.value;
        if (!stopLocation) return null;
        const lat = Number(stopLocation.lat);
        const lng = Number(stopLocation.lng);
        const isValid = 
          stopLocation.address?.trim() &&
          !isNaN(lat) && lat !== 0 &&
          !isNaN(lng) && lng !== 0;

        return isValid ? (ctrl as FormGroup) : null;
      })
      .filter((c) => c !== null) as FormGroup[];
  }

  addStopField() {
    this.stopsArray.push(
      this.formBuilder.group({
        address: [''],
        lat: [null],
        lng: [null],
        area_name: [''],
        city_name: [''],
        pincode: [null],
        complete_address: [''],
      })
    );
    this.stopContactsArray.push(
      this.formBuilder.group({
        stop_contact_name: [''],
        stop_contact_number: [''],
        stop_category: ['pickup'],
      })
    );
  }

  public tripBooking() {
    const characterRegex = /^[a-zA-Z][a-zA-Z\\s]+$/;
    const numericRegex = /^[0-9]{4,10}$/;
    const pincodeRegex = /^\d{6}$/;
    const contactRegex = /^[a-zA-Z][a-zA-Z\\s]+$/;
    this.loading = true;
    if (this.billingEdit === true) {
      this.loading = true;
      if (
        this.billingForm.value.name === "" ||
        !characterRegex.test(this.billingForm.value.name)
      ) {
        this.snackBar.open("Please enter correct name", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (this.billingForm.value.address === "") {
        this.snackBar.open("Please enter address", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (this.billingForm.value.email === "") {
        this.snackBar.open("Please enter email", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (
        this.billingForm.value.city === "" ||
        !characterRegex.test(this.billingForm.value.city)
      ) {
        this.snackBar.open("Please enter correct city", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (
        this.billingForm.value.state === "" ||
        !characterRegex.test(this.billingForm.value.state)
      ) {
        this.snackBar.open("Please enter state", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (
        this.billingForm.value.pincode === "" ||
        !pincodeRegex.test(this.billingForm.value.pincode)
      ) {
        this.snackBar.open("Please enter correct pincode", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
    }
    if (this.billingForm.value.pickup_name === "") {
      this.snackBar.open("Please enter correct pickup name", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (
      this.billingForm.value.pickup_contact === "" ||
      !numericRegex.test(this.billingForm.value.pickup_contact)
    ) {
      this.snackBar.open("Please enter correct pickup contact", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (this.billingForm.value.dropoff_name === "") {
      this.snackBar.open("Please enter correct dropoff name", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (
      this.billingForm.value.dropoff_contact === "" ||
      !numericRegex.test(this.billingForm.value.dropoff_contact)
    ) {
      this.snackBar.open("Please enter correct dropoff contact", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (
      this.billingForm.value.payment_mode === "" ||
      this.payment_check === false
    ) {
      this.snackBar.open("Please check the payment mode", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (this.billingForm.value.pay_as_load_quantity === "") {
      this.snackBar.open("Please check the load quantity", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (
      this.billingForm.value.terms_and_conditions === "" ||
      this.terms_check === false
    ) {
      this.snackBar.open("Please check the terms and conditions", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (this.billingForm.value.insurance_acknowledgement !== true) {
      this.snackBar.open(
        "Please acknowledge the insurance responsibility",
        "Fail",
        { duration: 5000 }
      );
      this.loading = false;
      return;
    }

    var token = sessionStorage.getItem("corporate_token");
    const gstValue = this.billingEdit
      ? this.billingForm.value.gst
      : this.profileDetails.gst;
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    const isValidGST = gstRegex.test((gstValue || "").toUpperCase());
    let selectedGstMode = this.billingForm.value.gst_mode || "fcm";
    // Force FCM if GST is invalid
    if (!isValidGST) {
      selectedGstMode = "fcm";
    }

    const tax_details = {
      hsn_code: this.selectedMaterial?.hsn_code || null,
      gst_mode: selectedGstMode,
      gst_deduction: selectedGstMode === "fcm"
        ? this.selectedMaterial?.fcm_deduction || 0
        : this.selectedMaterial?.rcm_deduction || 0,
    };
    const tripBookData: any = {
      from_complete_address:
        this.completePickUpAddress?.formatted_address ||
        this.searchPickupDetails.completePickUpAddress?.formatted_address,
      pickup_details: {
        from_area_name: `${this.pickup_state}, ${this.pickup_country}` || this.pickup_long_name,
        from_city_name: this.pickup_short_name,
        from_lat:
          this.SearchTruckDetails?.completePickUpAddress?.navigation_points?.[0]?.location?.latitude ||
          (this.pickupLat && !isNaN(Number(this.pickupLat)) ? (Math.round(Number(this.pickupLat) * 10000) / 10000).toString() : this.SearchTruckDetails?.fromLocation?.from_lat || ""),
        from_long:
          this.SearchTruckDetails?.completePickUpAddress?.navigation_points?.[0]?.location?.longitude ||
          (this.pickupLong && !isNaN(Number(this.pickupLong)) ? (Math.round(Number(this.pickupLong) * 10000) / 10000).toString() : this.SearchTruckDetails?.fromLocation?.from_long || ""),
        from_pincode: Number(this.pickup_postal_code) || 0,
      },

      to_complete_address:
        this.completeDropAddress?.formatted_address ||
        this.searchPickupDetails.completeDropAddress?.formatted_address,
      dropoff_details: {
        to_area_name: `${this.drop_state}, ${this.drop_country}` || this.drop_long_name,
        to_city_name: this.drop_short_name,
        to_lat: this.SearchTruckDetails?.completeDropAddress?.navigation_points?.length
          ? this.SearchTruckDetails.completeDropAddress.navigation_points[0].location.latitude
          : (this.dropLat && !isNaN(Number(this.dropLat)) ? (Math.round(Number(this.dropLat) * 10000) / 10000).toString() : this.SearchTruckDetails?.toLocation?.to_lat || ""),
        to_long: this.SearchTruckDetails?.completeDropAddress?.navigation_points?.length
          ? this.SearchTruckDetails.completeDropAddress.navigation_points[0].location.longitude
          : (this.dropLong && !isNaN(Number(this.dropLong)) ? (Math.round(Number(this.dropLong) * 10000) / 10000).toString() : this.SearchTruckDetails?.toLocation?.to_long || ""),
        to_pincode: Number(this.dropoff_postal_code) || 0,
      },
      pickup_date: formatDate(
        this.coordinatesForm.value.date,
        "yyyy-MM-dd",
        "en"
      ),
      truck_category: this.coordinatesForm.value.truck_category_name,
      total_tons: Number(this.coordinatesForm.value.total_tons),
      price_per_ton: this.coordinatesForm.value.price_type === 'total_price' ? 
        Number(this.coordinatesForm.value.total_price) / Number(this.coordinatesForm.value.total_tons) : 
        Number(this.coordinatesForm.value.price_per_ton),
      tax_details,
      load_type: this.loadSelectedCategory,
      material_type: this.billingForm.value.material,
      billing_address: {
        username: this.billingEdit
          ? this.billingForm.value.username
          : this.profileDetails.username,
        address_line: this.billingEdit
          ? this.billingForm.value.address_line
          : this.profileDetails.address_line,
        email: this.billingEdit
          ? this.billingForm.value.email
          : this.profileDetails.email,
        area_name: this.billingEdit ? "" : this.profileDetails.area_name,
        city: this.billingEdit
          ? this.billingForm.value.city
          : this.profileDetails.city,
        state: this.billingEdit
          ? this.billingForm.value.state
          : this.profileDetails.state,
        pincode: this.billingEdit
          ? this.billingForm.value.pincode
          : this.profileDetails.pincode,
        mobile: this.billingEdit ? "" : this.profileDetails.mobile,
        gst: this.billingEdit ? "" : this.profileDetails.gst,
        landmark: this.billingEdit ? "" : this.profileDetails.landmark,
      },
      pickup_contact: Number(this.billingForm.value.pickup_contact),
      pickup_name: this.billingForm.value.pickup_name,
      dropoff_contact: Number(this.billingForm.value.dropoff_contact),
      dropoff_name: this.billingForm.value.dropoff_name,
      terms_and_conditions: this.billingForm.value.terms_and_conditions,
      pay_as_load_quantity: this.selectedLoadedQuantity,
      insurance_acknowledgement: this.billingForm.value.insurance_acknowledgement,
      payment_mode: "offline",
    };
    
    const stopLocations = this.stopsArray?.value || [];
    const stopContacts = this.stopContactsArray?.value || [];
    interface StopWrapper {
      stop: any;
      index: number;
    }
    const combinedValidStops: StopWrapper[] = stopLocations
      .map((stop: any, index: number): StopWrapper => ({ stop, index }))
      .filter(({ stop }: StopWrapper) => {
        const lat = Number(stop.lat);
        const lng = Number(stop.lng);
        return (
          stop.address?.trim() &&
          !isNaN(lat) &&
          lat !== 0 &&
          !isNaN(lng) &&
          lng !== 0
        );
      });
    tripBookData["stops"] = combinedValidStops.map(
      ({ stop, index }: StopWrapper) => ({
        area_name: stop.area_name?.trim() || "",
        city_name: stop.city_name?.trim() || "",
        lat: Number(stop.lat).toFixed(4),
        lng: Number(stop.lng).toFixed(4),
        pincode: stop.pincode || 0,
        complete_address:
          stop.complete_address?.trim() ||
          stop.address?.trim() ||
          "",
        // contact fields based on original index
        stop_contact_name: stopContacts[index]?.stop_contact_name || "",
        stop_contact_number: stopContacts[index]?.stop_contact_number || "",
        stop_category: stopContacts[index]?.stop_category || "pickup",
      })
    );
    console.log("tripBookData", tripBookData);
    this.services.TripBooking(tripBookData, token).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.loading = false;
          this.downImg3 = false;
          this.checkImg3 = true;
          this.router.navigateByUrl("/corporate/work-order-list");
        }
      },
      (error) => {
        this.loading = false;
        if (error?.error?.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error?.error?.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error?.error?.message || "Something went wrong! Please try again.", "Fail", {
          duration: 5000,
        });
      }
    );
  }
  updateBillingAddress() {
    const billingAddress = {
      billing_address: {
        username: this.billingEdit
          ? this.billingForm.value.username
          : this.profileDetails.username,
        state: this.billingEdit
          ? this.billingForm.value.state
          : this.profileDetails.state,
        address_line: this.billingEdit
          ? this.billingForm.value.address_line
          : this.profileDetails.address_line,
        email: this.billingEdit
          ? this.billingForm.value.email
          : this.profileDetails.email,
        landmark: this.billingEdit ? "" : this.profileDetails.landmark,
        pincode: this.billingEdit
          ? this.billingForm.value.pincode
          : this.profileDetails.pincode,
        area_name: this.billingEdit ? "" : this.profileDetails.area_name,
        gst: this.billingEdit
          ? this.billingForm.value.gst?.toUpperCase() || ""
          : this.profileDetails.gst,
        mobile: this.billingEdit ? "" : this.profileDetails.mobile,
        city: this.billingEdit
          ? this.billingForm.value.city
          : this.profileDetails.city,
      },
    };
    this.services.UpdateProfile(billingAddress, this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.getProfileDetails();
          this.editBilling = true;
          this.billingEdit = false;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  editBookingDetails() {
    this.panelForm = true;
    this.panel = true;
    this.TruckDetailsBtn = true;
    this.checkImg = true;
    this.panel2form1 = false;
    this.loadDetailsBtn = false;
    this.paymentBtn = false;
    this.downImg = false;
    this.payment_condition = false;
    this.panel3form1 = false;
  }
  editLoadDetails() {
    this.panel2 = true;
    this.panel2form1 = true;
    this.loadDetailsBtn = true;
    this.downImg = false;
    this.checkImg = true;
    this.panel3 = false;
    this.panel3form1 = false;
    this.TruckDetailsBtn = false;
    this.paymentBtn = false;
    this.payment_condition = false;
  }
  getWebPages(selectedType: any) {
    window.open(`/webPages/${selectedType}`);
  }
  selectedType(event: any) {
    this.payment_check = event.checked;
  }
  selectedTerms(event: any) {
    this.terms_check = event.checked;
  }
  clearPickField() {
    this.coordinatesForm.get("from_area_name")?.setValue("");
    this.showCloseIconPick = false;
    this.onInputPickUpchange(event);
  }
  clearDropField() {
    this.coordinatesForm.get("to_area_name")?.setValue("");
    this.showCloseIconDrop = false;
    this.onDropChange(event);
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
